import type { DynamicIslandActivity } from '../../../../context/dynamicIslandTypes'
import { activityIslandAccent, activityPreviewProgress } from '../../../../lib/dynamicIsland/categoryOrder'
import {
  dynamicIslandAccentClass,
  dynamicIslandProgressFillClass,
  dynamicIslandProgressTrackClass,
  dynamicIslandSourceTagClass,
  dynamicIslandStatusChipClass,
} from '../../../../lib/dynamicIsland/dynamicIslandPresentation'

type Props = {
  activity: DynamicIslandActivity
  angular: boolean
}

function DynamicIslandActivityDetailFallback({ activity }: { activity: DynamicIslandActivity }) {
  const { expanded, sourceLabel, lifecycle } = activity
  const accent = activityIslandAccent(activity)
  const progress = activityPreviewProgress(activity)
  const progressTrack = dynamicIslandProgressTrackClass(false)
  const progressFill = dynamicIslandProgressFillClass({
    accent,
    progressPercent: progress,
    lifecycle,
  })

  return (
    <div className="glyphicai-dynamic-island-detail-fallback space-y-3">
      <div className="flex items-start gap-2.5 rounded-[var(--radius-sm)] border border-line/55 bg-surface-muted/40 px-3 py-2.5">
        <span
          className={['glyphicai-dynamic-island-activity__accent', dynamicIslandAccentClass(accent)].join(' ')}
          aria-hidden
        />
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-1.5">
            <span className={dynamicIslandSourceTagClass()}>{sourceLabel}</span>
            {lifecycle === 'active' && expanded.statusLabel ? (
              <span className={dynamicIslandStatusChipClass(accent)}>{expanded.statusLabel}</span>
            ) : null}
          </div>
          <p className="mt-1 text-sm font-semibold leading-snug text-ink">{expanded.title}</p>
          <p className="mt-0.5 text-xs leading-snug text-ink-soft">{expanded.description}</p>
        </div>
      </div>
      {progress > 0 || lifecycle === 'active' ? (
        <div className={progressTrack}>
          <span
            className={['glyphicai-dynamic-island-activity__progress-fill', progressFill].join(' ')}
            style={{ width: `${progress}%` }}
          />
        </div>
      ) : null}
    </div>
  )
}

export function DynamicIslandActivityDetailContent({ activity, angular: _angular }: Props) {
  return activity.renderDetail?.() ?? <DynamicIslandActivityDetailFallback activity={activity} />
}
